/* eslint-disable import/prefer-default-export */
import type * as Actions from '@src/redux/actions/auth.actions'
import * as ActionTypes from '@src/redux/actionTypes'
import { defaultState, AuthState } from './default.state'
import { SnapshotStateEnum } from './models'
import { cloneDeep } from 'lodash'

export function reducer(
  state: AuthState = defaultState,
  action: Actions.ActionTypes
): AuthState {
  switch (action.type) {
    case ActionTypes.Auth.GET_TENANT_SUCCESS: {
      return {
        ...state,
        singleAccounts:
          action?.payload?.singleAccounts ||
          state?.singleAccounts ||
          defaultState.singleAccounts,
        organizations:
          action?.payload?.organizations ||
          state?.organizations ||
          defaultState.organizations,
        tenant: action.payload.tenant,
        isLoggedIn: true,
        isPending: false
      }
    }

    case ActionTypes.Auth.GET_USER_SUCCESS: {
      return {
        ...state,
        user: action.payload.user,
        isPending: false
      }
    }

    case ActionTypes.Auth.GET_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        tenant: {
          ...state.tenant,
          alertSettings: action.payload.info
        },
        isPending: false
      }
    }

    case ActionTypes.Auth.SERVER_ERRORS: {
      return {
        ...state,
        errors: action.payload.errors,
        isPending: false
      }
    }

    case ActionTypes.Auth.GET_PROGRESS_SUCCESS: {
      return {
        ...state,
        progressList: action.payload.getProgressResp,
        isPendingProgress: false,
        snapshotState: {
          lastErrorTimestamp: null,
          snapshotState: SnapshotStateEnum.Normal,
          isRefreshTriggered:
            state?.snapshotState?.isRefreshTriggered ||
            defaultState.snapshotState.isRefreshTriggered,
          isRefreshing:
            state?.snapshotState?.isRefreshing ||
            defaultState.snapshotState.isRefreshing,
          lastRefreshTriggered:
            state?.snapshotState?.lastRefreshTriggered ||
            defaultState.snapshotState.lastRefreshTriggered
        }
      }
    }

    case ActionTypes.Auth.SET_SNAPSHOT_STATE: {
      return {
        ...state,
        snapshotState: cloneDeep(action.payload.snapshotState)
      }
    }

    case ActionTypes.Auth.SIGN_OUT_SUCCESS: {
      return {
        ...state,
        user: null,
        tenant: defaultState.tenant,
        isLoggedIn: false,
        isLoggedOut: true
      }
    }

    case ActionTypes.Auth.REQUEST_PENDING: {
      return {
        ...state,
        isPending: action.payload.isPending
      }
    }

    case ActionTypes.Auth.REQUEST_PENDING_PROGRESS: {
      return {
        ...state,
        isPendingProgress: action.payload.isPending
      }
    }

    case ActionTypes.Auth.ACCOUNT_REGISTER_PENDING: {
      return {
        ...state,
        accountRegisterPending: action.payload.accountRegisterPending
      }
    }

    case ActionTypes.Auth.LOGGED_IN: {
      return {
        ...state,
        isLoggedIn: action.payload.isLoggedIn,
        isLoggedOut: false
      }
    }

    case ActionTypes.Auth.GET_STAT_SUCCESS: {
      return {
        ...state,
        [action.payload.stat]: action.payload.value,
        isPending: false
      }
    }

    case ActionTypes.Auth.SET_SOURCES_IMPROVEMENTS_FF: {
      const { sourcesImprovementsFlag } = action.payload
      return { ...state, sourcesImprovementsFlag }
    }

    case ActionTypes.Auth.SET_IDN_API_URL: {
      const { idnAPIUrl } = action.payload
      return { ...state, idnAPIUrl }
    }

    default: {
      return state
    }
  }
}
